<template>
  <div>
    <v-checkbox
      class="text-primary mb-2 the-checkboxes"
      v-model="selected"
      v-for="{key, val, caption} in modifyOptions"
      :key="key"
      :value="+key"
      hide-details
      @change="handleChange"
      :color="color"
    >
      <template #label>
        <div class="chip-container">
          <div class="chip-item" :class="{active: value.includes(+key)}">
            <span :class="`text-${color}`">{{ transI18n(val) }}</span>
          </div> 
          <span class="fsz-16  ml-2">{{transI18n(caption)}}</span>
        </div>
      </template>
    </v-checkbox>
  </div>
</template>

<script>
export default {
  name: 'TheCheckboxes',
  props: {
    options: {
      required: true,
      type: Object,
    },
    value: {
      required: true,
      type: [Array, Number],
    },
    color: {
      type: String,
      default: 'blue',
    },
    transI18n: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      selected: this.value,
      olds: [],
      prefixObj: {
        "Nil a": this.$t('finding_words.use_of_anti-platelet_or_anti-coagulant'),
        "Nil b": this.$t('finding_words.unexpected_trouble_during_management_cardiopulmonary_event_other_complicaiotn_mechanical_etc'),
        "Nil c": this.$t('finding_words.difficulty_in_management_will_resect_at_another_sessio_of_colonoscopy'),
        "Nil d": this.$t('finding_words.difficulty_in_management_refer_to_other_hospital'),
        "Nil e": this.$t('finding_words.difficulty_in_management_refer_for_surgery'),
        "Nil f": this.$t('finding_words.consent_not_obtained_from_the_patient'),
        "Nil z": this.$t('finding_words.others'),
      }
    }
  },
  computed: {
    modifyOptions () {
      return Object.entries(this.options).map(([key, value]) => {
        return {
          key,
          val: value,
          caption: this.prefixObj[value] || ''
        }
      })
    }
  },
  watch: {
    value(val) {
      this.selected = Array.isArray(val) ? val : [val]
    },
  },
  methods: {
    handleChange(news) {
      this.$emit('change', news)
    },
  },
}
</script>

<style lang="scss">
.the-checkboxes {
  .v-input--selection-controls__input {
    position: absolute !important;
    opacity: 0 !important;
  }
}
.chip-container {
  display: flex;
}
.chip-item {
  white-space: nowrap;
  border: 1px solid #555;
  height: 28px;
  font-size: 24px;
  border-radius: 2px;
  padding: 4px;
  &.active {
    background: #1976d2 !important;
    border-color: #1976d2 !important;
    color: #fff;
  }
}
@media screen and (max-width:600px){
  .chip-item  {
    font-size: 20px;
  }
}
</style>
